/*
 * @Autor: lianxiben
 * @Date: 2021-05-25 14:16:10
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-06-10 14:52:57
 */
import base from "./base"; // 导入接口域名列表
import axios from "axios";
import qs from "qs"; //
const art = {
  //登录成功后获取区服信息
  getGameId(params) {
    return axios.get(
      `${base.url}/community/game/info?account=${params.account}&&app_id=58`,
      {
        withCredentials: true,
      }
    );
  },
  // 获取区服信息
  getGameIdNew(params) {
    return axios.post(`${base.url}/sword/book/get/role`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  //发送短信验证码
  sendMsg(params) {
    return axios.post(
      `${base.url}/snail/login/sms/send`,
      qs.stringify(params),
      {
        withCredentials: true,
      }
    );
  },
  //手机登录
  loginByPhone(params) {
    return axios.post(`${base.url}/sword/book/login`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  // 抽卡(1抽跟5抽)
  drawCard(params) {
    return axios.post(`${base.url}/sword/book/draw`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  //初始化
  init() {
    return axios.get(`${base.url}/sword/book/init`, {
      withCredentials: true,
    });
  },
  //获取红包列表
  getRedPageList() {
    return axios.get(`${base.url}/sword/book/list`, {
      withCredentials: true,
    });
  },
  // 抽奖
  lottery() {
    return axios.post(`${base.url}/sword/book/lotter`, qs.stringify(), {
      withCredentials: true,
    });
  },
  // 获取拜帖次数
  getbt(params) {
    return axios.post(`${base.url}/sword/book/home`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  // 千里传音
  phoneMusic(params) {
    return axios.post(
      `${base.url}/sword/book/phonation`,
      qs.stringify(params),
      {
        withCredentials: true,
      }
    );
  },
  // 支付
  payOne(params) {
    return axios.post(`${base.url}/sword/book/pay`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  //订单支付查询
  bingdingWating(params) {
    return axios.get(
      `${base.url}/sword/book/pay/query?trade_no=${params.trade_no}`,
      {
        withCredentials: true,
      }
    );
  },
  // 邀约侠客
  invited(params) {
    return axios.post(`${base.url}/sword/book/invite`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  // 道具领取
  getDj() {
    return axios.get(`${base.url}/sword/book/reward`, {
      withCredentials: true,
    });
  },
  //完成任务
  shareBtn(params) {
    return axios.get(`${base.url}/sword/book/share?task_id=${params.taskId}`, {
      withCredentials: true,
    });
  },
  //注销
  loginout() {
    return axios.get(`${base.url}/sword/book/login/out`, {
      withCredentials: true,
    });
  },
  // 实物领取
  swlq(params) {
    return axios.post(`${base.url}/sword/book/address`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  //红包提取
  hbJl(params) {
    return axios.post(`${base.url}/sword/book/red`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  //微信授权
  wechatAuthorization() {
    return axios.get(`${base.url}/wechat/info`, {
      withCredentials: true,
    });
  },
  // jssdk
  settingShare(params) {
    return axios.post(`${base.url}/wechat/jssdk`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  // 邀请记录
  inviteRecord(params) {
    return axios.get(
      `${base.url}/sword/book/invite/record?page=${params.page}`,
      {
        withCredentials: true,
      }
    );
  },
  //每日分享
  shareOneDay() {
    return axios.get(`${base.url}/sword/book/day/share`, {
      withCredentials: true,
    });
  },
  //角色绑定
  bingding(params) {
    return axios.post(
      `${base.url}/sword/book/role/binds`,
      qs.stringify(params),
      {
        withCredentials: true,
      }
    );
  },
  // 预约人数
  peopleNum() {
    return axios.get(`${base.url}/sword/book/people`, {
      withCredentials: true,
    });
  },
  // PC跳转H5免密登录
  nonDenseLogin(params) {
    return axios.post(
      `${base.url}/sword/book/free/login`,
      qs.stringify(params),
      {
        withCredentials: true,
      }
    );
  },
  // 奖励补发
  bonusReissue(params) {
    return axios.post(
      `${base.url}/sword/book/rewward/recharge`,
      qs.stringify(params),
      {
        withCredentials: true,
      }
    );
  },
  // 支付测试
  paytest(params) {
    return axios.post(`${base.url}/game/clock/test/pay`, qs.stringify(params), {
      withCredentials: true,
    });
  },
  // 退款
  returrnApi(params) {
    return axios.get(
      `${base.url}/game/clock/test/refunds?trade_no=${params.trade_no}&pay_type=alipay`,
      {
        withCredentials: true,
      }
    );
  },
};

export default art;
